import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ConfirmationDialogOptions {
  title: string;
  message: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  confirmButtonColor?: "primary" | "secondary" | "error" | "inherit" | "success" | "warning";
  onConfirm: () => void;
  onCancel?: () => void;
}

interface ConfirmationDialogState {
  isOpen: boolean;
  options: ConfirmationDialogOptions | null;
}

const initialState: ConfirmationDialogState = {
  isOpen: false,
  options: null,
};

const confirmationDialogSlice = createSlice({
  name: 'confirmationDialog',
  initialState,
  reducers: {
    showConfirmationDialog: (state, action: PayloadAction<ConfirmationDialogOptions>) => {
      state.isOpen = true;
      state.options = action.payload;
    },
    hideConfirmationDialog: (state) => {
      state.isOpen = false;
      state.options = null;
    },
  },
});

export const { showConfirmationDialog, hideConfirmationDialog } = confirmationDialogSlice.actions;
export const confirmationDialogReducer = confirmationDialogSlice.reducer;
